import React from 'react'
import PropTypes from 'prop-types'

const User = (props) => {
  return (
    <h5 className="centered" style={{marginBottom: '25px'}}>
      Hello {props.user}
    </h5>
  )
}

User.displayName = 'User'
User.propTypes = {
  user: PropTypes.string
}

export default User



// WEBPACK FOOTER //
// ./src/components/aside/User.js